// TwoTwoFiveSeven.jsx
'use strict';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { sanitize } from 'isomorphic-dompurify';
import { color, headerHeight } from '../style/variables.js';
import preventPullToRefresh from '../resource/preventPullToRefresh.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import BackIconSource from '../../img/ic_topbar_back.svg';
import { NULL_FUNCTION } from '../resource/defaults.js';

const SANITIZE_CONFIG = { ADD_TAGS: ['style'], FORCE_BODY: true };

class TwoTwoFiveSeven extends React.PureComponent {
  componentDidMount() {
    this.unsubscribe = preventPullToRefresh('body');
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleDescriptionClick = e => {
    const anchor = e.target.closest('a[href^="mailto:"]');
    if (anchor) {
      e.preventDefault();
      this.props.handleMailTo();
    }
  };

  render() {
    const { goBack, t } = this.props;
    const string = t('2257_seo_description', {
      ns: TranslationNamespace.SETTINGS,
      interpolation: { prefix: '#__NONE__#', suffix: '#__NONE__#' },
    });
    const dangerousHtml = { __html: sanitize(string, SANITIZE_CONFIG) };

    return (
      <StyledTwoTwoFiveSeven>
        <Header>
          <CloseButton onClick={goBack} role="button">
            <CloseIcon src={BackIconSource} title="close" />
          </CloseButton>
          <HeaderTitle>2257</HeaderTitle>
        </Header>
        <Body>
          <Description
            dangerouslySetInnerHTML={dangerousHtml}
            onClick={this.handleDescriptionClick}
          />
        </Body>
      </StyledTwoTwoFiveSeven>
    );
  }
}

TwoTwoFiveSeven.propTypes = {
  goBack: PropTypes.func.isRequired,
  t: PropTypes.func,
  handleMailTo: PropTypes.func,
};

TwoTwoFiveSeven.defaultProps = {
  t: NULL_FUNCTION,
  handleMailTo: NULL_FUNCTION,
};

const StyledTwoTwoFiveSeven = styled.div`
  margin-top: var(--space-to-pinned-notification);
`;

const Header = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${headerHeight}px;
  background-color: #232323;
`;

const CloseButton = styled.button`
  position: absolute;
  left: 0;
  border: 0;
  padding: 14px 16px;
  background: none;
  cursor: pointer;
  outline: 0;
  :hover {
    opacity: 0.7;
  }
`;

const CloseIcon = styled.img`
  width: 30px;
  height: 30px;
  vertical-align: top;
`;

const HeaderTitle = styled.div`
  margin: 0px;
  font-size: 16px;
  color: ${color.white};
`;

const Body = styled.div`
  border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  border-top: 1px solid rgb(100, 100, 100, 0.5);
  padding: 30px 16px;
  background-color: #232323;
  overflow: hidden;
`;

const Description = styled.div`
  font-size: 14px;
  text-align: justify;
  line-height: 1.43;
`;

export default withTranslation()(TwoTwoFiveSeven);
